module.exports = __webpack_public_path__ + "static/media/patrol(10).1ecc00e4.PNG";